import { configuration } from "./Configuration";
import { authenticatedFetch } from "./JWTAuthService";
import { getEntityType } from "@the-real-insight/tri-model";
import { handleResponseArray } from "./UserAPI";

const baseUrl = configuration.serverUrl;

export const getKnowledgeBases = async (customerID: string): Promise<any[]> => {
  const response = await authenticatedFetch(
    `${baseUrl}/${customerID}/knowledge-bases`,
    { method: "GET" }
  );

  return await handleResponseArray(response, (entity: any) => {
    return new (getEntityType(entity._type).type.type)(entity);
  });
};

export const setManagedFiles = async (
  customerID: string,
  knowledgeBaseId: string,
  managedFiles: string[]
) => {
  const response = await authenticatedFetch(
    `${baseUrl}/${customerID}/knowledge-bases/${knowledgeBaseId}/managed-files`,
    {
      method: "POST",
      body: JSON.stringify({ managedFiles }),
    }
  );

  return response.json();
};

export const getKnowledgeBasesForFile = async (
  customerID: string,
  fileId: string
) => {
  const response = await authenticatedFetch(
    `${baseUrl}/${customerID}/knowledge-bases/file/${fileId}`,
    { method: "GET" }
  );

  return response.json();
};
